import Flex from '@eversports/react-components/primitives/Flex'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../../../localization/react'
import { PriceTableItemMembership } from '../../../typings/PriceTable'

interface Props {
  membership: PriceTableItemMembership
}

const PartialPriceMembershipSummaryItem: React.FC<React.PropsWithChildren<Props>> = ({ membership }) => {
  if (!membership.partialPriceTimeRange || !membership.totalPrice) {
    throw new Error('Partial price membership doesnt have partial price time range or total price')
  }

  const partialPriceEndDate = new Date(membership.partialPriceTimeRange.end)
  const regularRuntimeStartDate = new Date(partialPriceEndDate).setDate(partialPriceEndDate.getDate() + 1)

  return (
    <Flex flexDirection="column" verticalSpacing="default">
      <Text marginRight="dense">{membership.name}</Text>
      <Flex justifyContent="space-between" alignItems="baseline" horizontalSpacing="dense">
        <Flex flexDirection="column">
          <Text>
            <Localized
              id="summary-partial-payment-period"
              params={{
                start: new Date(membership.partialPriceTimeRange.start),
                end: new Date(membership.partialPriceTimeRange.end),
              }}
            />
          </Text>
          <Text size="x-small" color="subtleText">
            <Localized id="partial-payment-period" />
          </Text>
        </Flex>
        <Text fontWeight="bold" marginLeft="dense">
          <MonetaryValue value={membership.totalPrice.value} currencyCode={membership.totalPrice.currency} />
        </Text>
      </Flex>
      <Flex justifyContent="space-between" alignItems="baseline" horizontalSpacing="dense">
        <Flex flexDirection="column">
          <Text color="subtleText">
            <Localized
              id="summary-start-of-regular-runtime"
              params={{
                start: regularRuntimeStartDate,
              }}
            />
          </Text>
          <Text size="x-small" color="subtleText">
            <Localized id="start-of-regular-runtime" />
          </Text>
        </Flex>
        <Flex flexDirection="column" alignItems="center">
          <Text color="subtleText" fontWeight="bold">
            <MonetaryValue value={membership.recurringPrice.value} currencyCode={membership.recurringPrice.currency} />
          </Text>
          {membership.paymentInterval && (
            <Text size="x-small" color="subtleText">
              <Localized
                id="membership-interval"
                params={{
                  interval: (
                    <Localized
                      id="interval"
                      params={{
                        intervalValue: membership.paymentInterval.value,
                        intervalType: membership.paymentInterval.type as any,
                      }}
                    />
                  ),
                }}
              />
            </Text>
          )}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default PartialPriceMembershipSummaryItem
